import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNotifyOutlined = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M10 2C10.5312 2 11 2.46875 11 3V3.625C13.2812 4.0625 15 6.09375 15 8.5V9.3125C15 10.7187 15.4688 12.0937 16.3438 13.2187L16.8125 13.7812C17 14.0312 17.0312 14.3437 16.9062 14.5937C16.7812 14.8437 16.5312 15 16.25 15L3.75 15C3.4375 15 3.1875 14.8438 3.0625 14.5938C2.9375 14.3438 2.96875 14.0312 3.15625 13.7812L3.625 13.2188C4.5 12.0938 5 10.7188 5 9.3125L5 8.5C5 6.09375 6.71875 4.0625 9 3.625V3C9 2.46875 9.4375 2 10 2ZM10 5C8.0625 5 6.5 6.59375 6.5 8.5V9.3125C6.5 10.8125 6.0625 12.25 5.25 13.5L14.7188 13.5C13.9063 12.25 13.5 10.8125 13.5 9.3125V8.5C13.5 6.59375 11.9062 5 10 5ZM12 16C12 16.5312 11.7813 17.0625 11.4063 17.4375C11.0313 17.8125 10.5313 18 10 18C9.46875 18 8.9375 17.8125 8.5625 17.4375C8.1875 17.0625 8 16.5312 8 16H10H12Z"
	})
});
const ForwardRef = forwardRef(SvgNotifyOutlined);
export default ForwardRef;
